import { Users } from "../../components/AdminLayout/UserManagement";
import AdminLayout from "../../components/AdminLayout";

export function Usermanagemnt() {
  return (
    <AdminLayout>
      <Users />
    </AdminLayout>
  );
}
